module.exports = __webpack_public_path__ + "img/arrow_2.04bffb25.png";